import classNames from 'classnames';
import { X } from 'react-feather';
var SubInstruction = function (_a) {
    var instruction = _a.instruction, className = _a.className, _b = _a.open, open = _b === void 0 ? false : _b, close = _a.close;
    return (<>
      {open && (<div className={classNames('mb-2.5 flex justify-between bg-gray-200 p-3 text-xs text-gray-700', className)}>
          {instruction}
          <X size={16} className="ml-2 flex-none cursor-pointer fill-gray-700" onClick={function () { return close(); }}/>
        </div>)}
    </>);
};
export default SubInstruction;
